import {
  MICROFRONTEND_ROUTES,
  type MicrofrontendRoutes,
} from "@spiriidk/connect-configs";

const isRouteServedBy = (
  pathname: string,
  microfrontend: keyof MicrofrontendRoutes
): boolean => {
  const config = MICROFRONTEND_ROUTES[microfrontend];
  return config.paths.some((path) => pathname.startsWith(path));
};

/**
 * Determines if a route is served by the connect app.
 */
const isConnectRoute = (pathname: string): boolean => {
  return isRouteServedBy(pathname, "connect");
};

/**
 * Determines if a route is served by the techUi app.
 */
const isTechUiRoute = (pathname: string): boolean => {
  return isRouteServedBy(pathname, "techUi");
};

export { isRouteServedBy, isConnectRoute, isTechUiRoute };
